import { Link } from "react-router-dom";
import { Anchor } from "lucide-react";

/**
 * Site-wide promo band for The Captain's Welcome (Saturday, first 350 ticket
 * scans). Dropped in below the hero on high-traffic pages — homepage,
 * /tickets, /lineup, /guide, /schedule, /parking. Delete the usages after
 * July 18.
 */
const CaptainsWelcomeBand = () => (
  <Link
    to="/captains-welcome"
    className="block bg-yacht-blue hover:brightness-110 transition-all border-y-4 border-yacht-yellow"
    aria-label="The Captain's Welcome — Saturday, first 350 aboard"
  >
    <div className="max-w-6xl mx-auto px-5 md:px-8 py-3.5 md:py-4 flex items-center justify-center gap-3 md:gap-4">
      <Anchor className="w-4 h-4 md:w-5 md:h-5 shrink-0 text-yacht-yellow" aria-hidden />
      <p className="text-[13px] md:text-[15px] leading-snug font-semibold text-center text-white">
        <span className="font-extrabold uppercase tracking-wide text-yacht-yellow">
          Saturday · The Captain's Welcome:
        </span>{" "}
        first 350 through the gates get free breakfast, free parking &amp; a
        welcome bag
        <span className="ml-2 underline underline-offset-2 whitespace-nowrap font-extrabold text-yacht-yellow">
          See what you get →
        </span>
      </p>
    </div>
  </Link>
);

export default CaptainsWelcomeBand;
